export const iconHamburger = require('./hamburger.svg');
export const iconClose = require('./close.svg');
export const iconCloseWhite = require('./close-white.svg');
export const googleIcon = require('./google.png');
